import { api } from './client';

export const regioesEntregaApi = {
  listar: () => api.get('/regioes-entrega'),
  prazoParaEndereco: (uf, cidade) => api.get(`/regioes-entrega/prazo?uf=${encodeURIComponent(uf || '')}&cidade=${encodeURIComponent(cidade || '')}`),
  criar: (dados) => api.post('/regioes-entrega', dados),
  atualizar: (id, dados) => api.put(`/regioes-entrega/${id}`, dados),
  excluir: (id) => api.del(`/regioes-entrega/${id}`)
};
